import CModal from '../CModal';
import { IconStar } from '@tabler/icons-react';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { apiV1 } from '../../utils/apiClient';
import { useEffect, useState } from 'react';
import { profileQueryOptions, salesPointsQueryOptions } from '../../utils/queryOptions';
import { message, Select } from 'antd';

interface RedeemPointsModalProps {
  open: boolean,
  onClose: () => void,
  customerId: string,
  goalIndex: number | undefined
}

const RedeemPointsModal = ({ open, onClose, customerId, goalIndex }: RedeemPointsModalProps) => {

  const salesPoints = useSuspenseQuery(salesPointsQueryOptions());
  const shopProfile = useSuspenseQuery(profileQueryOptions());
  const queryClient = useQueryClient()

  const salesPointsOptions = salesPoints.data.map((point) => ({
    value: point.id,
    label: point.name
  }));
  const [selectedSalesPointId, setSelectedSalesPointId] = useState('');

  useEffect(() => {
    const savedSalesPointId = localStorage.getItem('selectedSalesPointId');
    if (savedSalesPointId) {
      setSelectedSalesPointId(savedSalesPointId);
    } else {
      setSelectedSalesPointId(salesPoints.data[0].id);
    }
  }, []);

  const redeemPointsMutation = {
    mutationFn: async () => await apiV1.post('/shop/transactions/redeem-points', {
      sales_point_id: selectedSalesPointId,
      qr_code: goalIndex+'%'+customerId
    }),
    onSuccess: (data: any) => {
      message.success(`Sono stati sottratti ${data.details} punti`);
      queryClient.invalidateQueries({queryKey: ['customer', customerId]})
      queryClient.invalidateQueries({queryKey: ['customer-history', customerId]})
      onClose()
    }
  }

  async function saveSalesPointPreference(salesPointId: string) {
    setSelectedSalesPointId(salesPointId);
    localStorage.setItem('selectedSalesPointId', salesPointId);
    message.success('Preferenza salvata');
  }

  if (goalIndex === undefined) return <div />;

  return (
    <CModal title={'Vuoi convalidare questo traguardo?'} open={open} onClose={onClose} icon={<IconStar />}
            mutationOptions={redeemPointsMutation}>
      <p className={'text-slate-500 mb-3'}>Verranno sottratti {
        shopProfile.data.goals[goalIndex].number
      } punti al cliente.</p>
      <p className={'font-medium'}>Punto vendita</p>
      <Select options={salesPointsOptions} value={selectedSalesPointId} onSelect={saveSalesPointPreference}
              className={'w-full'} />
    </CModal>
  );
};
export default RedeemPointsModal;
